import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 81,
	height: 81,
	viewBox: "0 0 81 81",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M40.329 78.4461C61.3805 78.4461 78.446 61.3805 78.446 40.3291C78.446 19.2776 61.3805 2.21204 40.329 2.21204C19.2775 2.21204 2.21198 19.2776 2.21198 40.3291C2.21198 61.3805 19.2775 78.4461 40.329 78.4461Z",
			stroke: "white",
			strokeWidth: 4.42397,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.329 78.4461C61.3805 78.4461 78.446 61.3805 78.446 40.3291C78.446 19.2776 61.3805 2.21204 40.329 2.21204C19.2775 2.21204 2.21198 19.2776 2.21198 40.3291C2.21198 61.3805 19.2775 78.4461 40.329 78.4461Z",
			fill: "url(#paint0_linear_43_320)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.329 11.4233C24.3909 11.4233 11.4233 24.3909 11.4233 40.3291C11.4233 56.2672 24.3909 69.2348 40.329 69.2348C56.2671 69.2348 69.2347 56.2672 69.2347 40.3291C69.2347 24.3909 56.2671 11.4233 40.329 11.4233Z",
			fill: "url(#paint1_radial_43_320)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.7977 30.894L31.059 31.6327L39.9587 40.5324L40.6974 39.7937L31.7977 30.894Z",
			fill: "#8B4A37"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.8513 40.161H39.8066V60.0598H40.8513V40.161Z",
			fill: "#8B4A37"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4766 40.1611C43.4766 41.9007 42.0686 43.3087 40.329 43.3087C38.5894 43.3087 37.1813 41.9007 37.1813 40.1611C37.1813 38.4215 38.5894 37.0134 40.329 37.0134C42.0686 37.0134 43.4766 38.4215 43.4766 40.1611Z",
			fill: "url(#paint2_linear_43_320)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4279 40.1611C17.4279 40.847 16.8738 41.4011 16.1879 41.4011C15.5021 41.4011 14.9479 40.847 14.9479 40.1611C14.9479 39.4753 15.5021 38.9211 16.1879 38.9211C16.8738 38.9211 17.4279 39.4753 17.4279 40.1611Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.7101 40.1611C65.7101 40.847 65.1559 41.4011 64.4701 41.4011C63.7842 41.4011 63.2301 40.847 63.2301 40.1611C63.2301 39.4753 63.7842 38.9211 64.4701 38.9211C65.1559 38.9211 65.7101 39.4753 65.7101 40.1611Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.329 63.2302C41.0148 63.2302 41.569 63.7844 41.569 64.4702C41.569 65.1561 41.0148 65.7102 40.329 65.7102C39.6431 65.7102 39.089 65.1561 39.089 64.4702C39.089 63.7844 39.6431 63.2302 40.329 63.2302Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.329 14.948C41.0148 14.948 41.569 15.5021 41.569 16.188C41.569 16.8738 41.0148 17.428 40.329 17.428C39.6431 17.428 39.089 16.8738 39.089 16.188C39.089 15.5021 39.6431 14.948 40.329 14.948Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.7795 60.1598C52.3745 59.8191 53.1331 60.019 53.4737 60.614C53.8144 61.209 53.6145 61.9675 53.0195 62.3082C52.4245 62.6489 51.666 62.449 51.3253 61.854C50.9847 61.259 51.1845 60.5004 51.7795 60.1598Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.6385 18.3455C28.2335 18.0048 28.992 18.2046 29.3327 18.7997C29.6733 19.3947 29.4735 20.1532 28.8785 20.4939C28.2834 20.8345 27.5249 20.6347 27.1843 20.0397C26.8436 19.4447 27.0435 18.6861 27.6385 18.3455Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.1642 51.7796C60.5048 51.1846 61.2634 50.9848 61.8584 51.3254C62.4534 51.6661 62.6532 52.4246 62.3126 53.0196C61.9719 53.6146 61.2134 53.8145 60.6184 53.4738C60.0234 53.1332 59.8235 52.3747 60.1642 51.7796Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3499 27.6385C18.6906 27.0435 19.4491 26.8437 20.0441 27.1843C20.6391 27.525 20.839 28.2835 20.4983 28.8785C20.1577 29.4735 19.3991 29.6734 18.8041 29.3327C18.2091 28.9921 18.0093 28.2335 18.3499 27.6385Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.8785 60.1598C28.2834 59.8191 27.5249 60.019 27.1843 60.614C26.8436 61.209 27.0435 61.9675 27.6385 62.3082C28.2335 62.6489 28.992 62.449 29.3327 61.854C29.6733 61.259 29.4735 60.5004 28.8785 60.1598Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.0195 18.3455C52.4245 18.0048 51.666 18.2046 51.3253 18.7997C50.9847 19.3947 51.1845 20.1532 51.7795 20.4939C52.3745 20.8345 53.1331 20.6347 53.4737 20.0397C53.8144 19.4447 53.6145 18.6861 53.0195 18.3455Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.4983 51.7796C20.1577 51.1846 19.3991 50.9848 18.8041 51.3254C18.2091 51.6661 18.0093 52.4246 18.3499 53.0196C18.6906 53.6146 19.4491 53.8145 20.0441 53.4738C20.6391 53.1332 20.839 52.3747 20.4983 51.7796Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.3126 27.6385C61.9719 27.0435 61.2134 26.8437 60.6184 27.1843C60.0234 27.525 59.8235 28.2835 60.1642 28.8785C60.5048 29.4735 61.2634 29.6734 61.8584 29.3327C62.4534 28.9921 62.6532 28.2335 62.3126 27.6385Z",
			fill: "#303651"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_43_320",
				x1: 40.329,
				y1: 74.4672,
				x2: 40.329,
				y2: -8.23018,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .07,
						stopColor: "#F9DF4B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .27,
						stopColor: "#F6D347"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .48,
						stopColor: "#F6D047"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .74,
						stopColor: "#F4BC41"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .77,
						stopColor: "#F3BA40"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#F3B53F"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_43_320",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(40.329 40.3291) scale(44.0808 44.0808)",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#D7E8EA" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .26,
						stopColor: "#D3E4E6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .49,
						stopColor: "#C9D9DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .72,
						stopColor: "#B8C6C8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .94,
						stopColor: "#A0ACAE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#98A4A6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_43_320",
				x1: 37.1813,
				y1: 40.1611,
				x2: 43.4766,
				y2: 40.1611,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#40201C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#633328"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#8B4A37"
					})
				]
			})
		] })
	]
});
export default SvgClock;
